export const editorContracts = {
  "contracts.createTpm": "contracts.createTpm",
  "contracts.createVasReq": "contracts.createVasReq",
  "editor.contracts.trusted.create": "editor.contracts.trusted.create",
  "editor.contracts.trusted.edit": "editor.contracts.trusted.edit",
  "contracts.changeVasReq": "contracts.changeVasReq",
  "contracts.updateVasReq": "contracts.updateVasReq",
  "contracts.deleteVasReq": "contracts.deleteVasReq",
} as const;
